import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=1b11060e&lang=pug&"
import script from "./Receive.vue?vue&type=script&lang=ts&"
export * from "./Receive.vue?vue&type=script&lang=ts&"
import style0 from "./Receive.vue?vue&type=style&index=0&id=1b11060e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports